import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _LoanDestination, _LoanLinePayrollEntity } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { MyEditor } from "../../../theme/Component/MyEditor";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { PayrollEntitySelect } from "../PayrollEntity/PayRollEntitySelect";

interface Props {
    idLoanLine: number;
}

export const LoanLinePayroollByLoanLine = ({ idLoanLine }: Props) => {

    const payrooll = useDataBean(_LoanLinePayrollEntity);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idLoanLine])

    const getLista = () => {
        payrooll.instance.getLoanLinePayrollEntityByLoanLine(idLoanLine)
            .then((resp: any) => {
                if (resp) {
                    const filtrados = resp.filter((item: any) => item.DataBeanProperties.State == 0);
                    setLista(filtrados);
                }
            })
            .catch(err => {
                toast.error(err);
            });
    }

    const create = () => {
        payrooll.setBean({
            IDLoanLine: idLoanLine
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        payrooll.instance.deleteLoanLinePayrollEntity(payrooll.bean.IDLoanLinePayrollEntity).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        ).catch(err => { toast.error(err) })

    }
    const editaItem = () => {
        payrooll.instance.addLoanLineToPayrollEntity(idLoanLine, payrooll.bean.IDPayrollEntity).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDLoanLinePayrollEntity', visible: true },

        { title: 'Línea de Crédito', property: 'LoanLineName', visible: true },
        { title: 'Caja Nominadora', property: 'PayrollEntityName', visible: true },
        { title: 'Observaciones', property: 'Description', visible: true },
        { title: 'Interes Corriente', property: 'CurrentPercentInterest', visible: true },
        { title: 'Interes en Mora', property: 'ExpiredPercentInterest', visible: true },
        { title: 'Habilitado', property: 'Enabled', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${payrooll.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Cajas Nominadoras">
            <div className="row">
                <div className="col-md-12">

                    <BasicTable
                        body={lista}
                        head={head}
                        rowSet={payrooll.setBean}
                        listButtons={listaBotones()}
                        iconButtons={iconButtonsItem}
                    />

                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <PayrollEntitySelect label="Selecciona Una Caja Nominadora" idSelector={payrooll.bean.IDPayrollEntity} onChange={(e) => { payrooll.setBean({ ...payrooll.bean, "IDPayrollEntity": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Interes Corriente</label>
                                <input type="number" name="CurrentPercentInterest" className="form-control" value={payrooll.bean.CurrentPercentInterest} onChange={payrooll.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <label>Interes en Mora</label>
                                <input type="number" name="ExpiredPercentInterest" className="form-control" value={payrooll.bean.ExpiredPercentInterest} onChange={payrooll.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch label="Habilitado" estado={payrooll.bean.Enabled} eventChange={(e) => { payrooll.setBean({ ...payrooll.bean, "Enabled": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Observaciones</label>
                                <MyEditor val={payrooll.bean.Description} onChange={(e: any) => { payrooll.setBean({ ...payrooll.bean, 'Description': e }) }} ></MyEditor>
                            </div>

                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {payrooll.bean.Name}</strong>
                    </ModalConfirm>
                </div>


            </div>
        </BasicPage>
    )
}